/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import {Route, Switch, Redirect} from 'react-router';
// pages
import AllReports from './allreports/allreports';
import NewReport from './newreport/newreport';
import ReportPreview from './reportpreview/reportpreview';


/* ========== ~~~~~~~~~~ REPORT BUILDER - ROUTES ~~~~~~~~~~ ========== */

export default () => {
    return (
        <Switch>
            <Route exact path='/dashboard/reportbuilder' render={() => <Redirect to={'/dashboard/reportbuilder/allreports'}/>}/>
            <Route path='/dashboard/reportbuilder/allreports' component={AllReports} />
            <Route path='/dashboard/reportbuilder/new' component={NewReport} />
            <Route path='/dashboard/reportbuilder/preview' component={ReportPreview} />
            <Redirect to='/error/404'/>
        </Switch>
    )
};
